import { createFileRoute } from '@tanstack/react-router'

import { UndeliveredScreen } from './-components/undelivered-screen.tsx'

export const Route = createFileRoute('/cs-tools/undelivered')({
  component: UndeliveredScreen
})
